import OccupationDropdown from './Occupation';
import '../css/Filter.css';
import LookUpRequest from "../model/request/LookupRequest";
import MultiSelectDropdown from './MultiSelectDropdown';
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import ProfileListData from '../model/response/ProfileListData';
import axios from 'axios';
import FilterRequest from '../model/request/FilterRequest';
import ApiResponse from '../model/response/ApiResponse';
import ApiConfig from '../utils/ApiConfig';
import { toast, ToastContainer } from 'react-toastify';
import { Oval } from "react-loader-spinner";
import Select from "react-select";
import Creatable from 'react-select/creatable';
import EducationDropdown from './Education';

function Filter({ apply }) {

    const logingender = localStorage.getItem("gender");

    // ----------------------------------------------------
    // STATES
    // ----------------------------------------------------

    const [age_From, setAge_From] = useState("");
    const [age_To, setAge_To] = useState([]);
    const [ageTwo, setAgeTwo] = useState("");

    const [gender, setGender] = useState();

    const [selectedReligion, setSelectedReligion] = useState([]);
    const [selectedMaritalStatus, setSelectedMaritalStatus] = useState([]);
    const [selectedMotherTongue, setSelectedMotherTongue] = useState([]);
    const [selectedIncome, setSelectedIncome] = useState([]);

    const [error, setError] = useState("");

    const [caste, setCaste] = useState([]);
    const [casteList, setCasteList] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [stateList, setStateList] = useState([]);
    const [state, setState] = useState([]);

    const [districtList, setDistrictList] = useState([]);
    const [district, setDistrict] = useState([]);

    const [selectedPhysicalStatus, setSelectedPhysicalStatus] = useState([]);

    const [heightFrom, setHeightFrom] = useState("");
    const [heightTo, setHeightTo] = useState("");

    const [selectedOccupation, setSelectedOccupation] = useState([]);
    const [selectedEducation, setSelectedEducation] = useState([]);

    const [selectedFamilyStatus, setSelectedFamilyStatus] = useState([]);
    const [selectedFamilyType, setSelectedFamilyType] = useState([]);
    const [selectedFamilyValue, setSelectedFamilyValue] = useState([]);

    const [selectedEmployment, setSelectedEmployment] = useState([]);

    const [living_Preference, setliving_Preference] = useState([]);

    // IMPORTANT:
    // GetFilterPreferences API response store here.
    const [savedFilterData, setSavedFilterData] = useState(null);

    // ----------------------------------------------------
    // LOGIN
    // ----------------------------------------------------

    const rawVal = localStorage.getItem('loginVal');

    let loginVal = rawVal ? JSON.parse(rawVal) : null;

    let token = loginVal ? loginVal.token : null;

    // ----------------------------------------------------
    // TOAST
    // ----------------------------------------------------

    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    // ----------------------------------------------------
    // RELIGION
    // ----------------------------------------------------

    const Religion = [
        { value: "1", label: "Hindu" },
        { value: "2", label: "Muslim" },
        { value: "3", label: "Muslim - Shia" },
        { value: "4", label: "Muslim - Sunni" },
        { value: "6", label: "Christian" },
        { value: "7", label: "Sikh" },
        { value: "8", label: "Jain - All" },
        { value: "9", label: "Jain - Digambar" },
        { value: "10", label: "Jain - Shwetambar" },
        { value: "12", label: "Parsi" },
        { value: "13", label: "Buddhist" },
        { value: "14", label: "Jewish" },
        { value: "15", label: "Inter-Religion" },
        { value: "16", label: "No Religious Belief" },
    ];

    // ----------------------------------------------------
    // INCOME
    // ----------------------------------------------------

    const Income = [
        { value: "1", label: "0 - 1 Lakh" },
        { value: "2", label: "1 - 2 Lakh" },
        { value: "3", label: "2 - 3 Lakhs" },
        { value: "4", label: "3 - 4 Lakhs" },
        { value: "5", label: "4 - 5 Lakhs" },
        { value: "6", label: "5 - 6 Lakhs" },
        { value: "7", label: "6 - 7 Lakhs" },
        { value: "8", label: "7 - 8 Lakhs" },
        { value: "9", label: "8 - 9 Lakhs" },
        { value: "10", label: "9 - 10 Lakhs" },
        { value: "11", label: "10 - 12 Lakhs" },
        { value: "12", label: "12 - 14 Lakhs" },
        { value: "13", label: "14 - 16 Lakhs" },
        { value: "14", label: "16 - 18 Lakhs" },
        { value: "15", label: "18 - 20 Lakhs" },
        { value: "16", label: "20 - 25 Lakhs" },
        { value: "17", label: "25 - 30 Lakhs" },
        { value: "18", label: "30 - 35 Lakhs" },
        { value: "19", label: "35 - 40 Lakhs" },
        { value: "20", label: "40 - 45 Lakhs" },
        { value: "21", label: "45 - 50 Lakhs" },
        { value: "22", label: "50 to 60 Lakhs" },
        { value: "23", label: "60 - 70 Lakhs" },
        { value: "24", label: "70 - 80 Lakhs" },
        { value: "25", label: "80 - 90 Lakhs" },
        { value: "26", label: "90 Lakhs - 1 Crore" },
        { value: "27", label: "1 Crore & Above" },
    ];

    // ----------------------------------------------------
    // AGE
    // ----------------------------------------------------

    const ages = [
        18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30, 31, 32, 33,
        34, 35, 36, 37, 38, 39, 40, 41,
        42, 43, 44, 45, 46, 47, 48, 49,
        50, 51, 52, 53, 54, 55, 56, 57,
        58, 59, 60
    ];

    // ----------------------------------------------------
    // MARITAL STATUS
    // ----------------------------------------------------

    const Martialstatus = [
        { value: "1", label: "Never Married" },
        { value: "2", label: "Widower" },
        { value: "3", label: "Divorced" },
        { value: "4", label: "Awaiting Divorce" },
    ];

    // ----------------------------------------------------
    // MOTHER TONGUE
    // ----------------------------------------------------

    const Mothertongue = [
        { value: "1", label: "Angika" },
        { value: "2", label: "Arunachali" },
        { value: "3", label: "Asami" },
        { value: "4", label: "Awadhi" },
        { value: "5", label: "Bengali" },
        { value: "6", label: "Bojpuri" },
        { value: "7", label: "Brij" },
        { value: "8", label: "Bihari" },
        { value: "9", label: "Badaga" },
        { value: "10", label: "Chatisgari" },
        { value: "11", label: "Dogri" },
        { value: "12", label: "English" },
        { value: "13", label: "French" },
        { value: "14", label: "Garhwali" },
        { value: "15", label: "Garo" },
        { value: "16", label: "Gujarati" },
        { value: "17", label: "Haryanvi" },
        { value: "18", label: "Himachali/Pahari" },
        { value: "19", label: "Hindi" },
        { value: "20", label: "Kanauji" },
        { value: "21", label: "Kanada" },
        { value: "22", label: "Kashmiri" },
        { value: "23", label: "Khandesi" },
        { value: "24", label: "Khasi" },
        { value: "25", label: "Khonkani" },
        { value: "26", label: "Koshali" },
        { value: "27", label: "Kumaoni" },
        { value: "28", label: "Kutchi" },
        { value: "29", label: "Lepcha" },
        { value: "30", label: "Ladacki" },
        { value: "31", label: "Magahi" },
        { value: "32", label: "Maithili" },
        { value: "33", label: "Malayalam" },
        { value: "34", label: "Manipuri" },
        { value: "35", label: "Marathi" },
        { value: "36", label: "Marwari" },
        { value: "37", label: "Miji" },
        { value: "38", label: "Mizo" },
        { value: "39", label: "Monpa" },
        { value: "40", label: "Nicobarese" },
        { value: "41", label: "Nepali" },
        { value: "42", label: "Oriya" },
        { value: "43", label: "Panjabi" },
        { value: "44", label: "Rajasthani" },
        { value: "45", label: "Sanskrit" },
        { value: "46", label: "Santhali" },
        { value: "47", label: "Sindhi" },
        { value: "48", label: "Sourashtra" },
        { value: "49", label: "Tamil" },
        { value: "50", label: "Telugu" },
        { value: "51", label: "Tripuri" },
        { value: "52", label: "Tulu" },
        { value: "53", label: "Urdu" },
        { value: "54", label: "Bagri Rajastani" },
        { value: "55", label: "Dhandhari/Jaipuri" },
        { value: "56", label: "Gujari/Gojari" },
        { value: "57", label: "Harauti" },
        { value: "58", label: "Lambadi" },
        { value: "59", label: "Malvi" },
        { value: "60", label: "Mevari" },
        { value: "61", label: "Mewati/Ahirwati" },
        { value: "62", label: "Nimadi" },
        { value: "63", label: "Shekhawati" },
        { value: "64", label: "Wagdi" },
    ];

    // ----------------------------------------------------
    // EMPLOYMENT
    // ----------------------------------------------------

    const EmploymentType = [
        { value: "1", label: "Government/PSU" },
        { value: "2", label: "Defence" },
        { value: "3", label: "Private" },
        { value: "4", label: "Business" },
        { value: "5", label: "SelfEmployeed" },
        { value: "6", label: "Not Working" },
    ];

    // ----------------------------------------------------
    // FAMILY
    // ----------------------------------------------------

    const FamilyStatus = [
        { value: "1", label: "Middle Class" },
        { value: "2", label: "Upper-Middle Class" },
        { value: "3", label: "Rich" },
        { value: "4", label: "Affluent" },
    ];

    const FamilyValue = [
        { value: "1", label: "Orthodox" },
        { value: "2", label: "Traditional" },
        { value: "3", label: "Moderate" },
        { value: "4", label: "Liberal" },
    ];

    const FamilyType = [
        { value: "1", label: "Joint" },
        { value: "2", label: "Nuclear" },
    ];

    // ----------------------------------------------------
    // LIVING PREFERENCE
    // ----------------------------------------------------

    const LivingPreference = [
        {
            value: "1",
            label: "Traditional / Groom's Home"
        },
        {
            value: "2",
            label: "Willing to live with Bride's Family"
        },
        {
            value: "3",
            label: "Independent"
        },
        {
            value: "4",
            label: "Flexible"
        }
    ];

    // ====================================================
    // FILTER API CALL
    // ====================================================

    function FilterAPICall() {

        console.log("Selected State:", state);
        console.log("Selected District:", district);
        console.log("Selected Caste:", caste);

        if (!validation()) {
            return;
        }

        var request = new FilterRequest();

        request.userId = loginVal.user_Id;

        request.age_From = parseInt(age_From);
        request.age_To = parseInt(ageTwo);

        // ------------------------------------------------
        // RELIGION
        // ------------------------------------------------

        request.religion = selectedReligion
            .map(item => item.value)
            .join(",");

        // ------------------------------------------------
        // CASTE
        // ------------------------------------------------

        request.cast = caste
            .map(item => item.value)
            .join(",");

        // ------------------------------------------------
        // STATE
        // IMPORTANT:
        // State API object has:
        // value = state code
        // id = state id
        // Backend expects id
        // ------------------------------------------------

        request.state = state
            .map(item => item.id)
            .join(",");

        // ------------------------------------------------
        // DISTRICT
        // ------------------------------------------------

        request.district = district
            .map(item => item.value)
            .join(",");

        // ------------------------------------------------
        // MARITAL STATUS
        // ------------------------------------------------

        request.marital_Status = selectedMaritalStatus
            .map(item => item.value)
            .join(",");

        // ------------------------------------------------
        // MOTHER TONGUE
        // ------------------------------------------------

        request.mother_Tongue = selectedMotherTongue
            .map(item => item.value)
            .join(",");

        // ------------------------------------------------
        // EMPLOYMENT
        // ------------------------------------------------

        request.employment_In = selectedEmployment
            .map(item => item.value)
            .join(",");

        // ------------------------------------------------
        // FAMILY STATUS
        // ------------------------------------------------

        request.family_Status = selectedFamilyStatus
            .map(item => item.value)
            .join(",");

        // ------------------------------------------------
        // FAMILY TYPE
        // ------------------------------------------------

        request.family_Type = selectedFamilyType
            .map(item => item.value)
            .join(",");

        // ------------------------------------------------
        // FAMILY VALUES
        // ------------------------------------------------

        request.family_Values = selectedFamilyValue
            .map(item => item.value)
            .join(",");

        // ------------------------------------------------
        // OCCUPATION
        // ------------------------------------------------

        request.occupation =
            selectedOccupation &&
            !Array.isArray(selectedOccupation)
                ? parseInt(selectedOccupation.id)
                : null;

        // ------------------------------------------------
        // EDUCATION
        // ------------------------------------------------

        request.education =
            selectedEducation &&
            selectedEducation.length > 0
                ? parseInt(selectedEducation[0].id)
                : null;

        // ------------------------------------------------
        // GENDER
        // ------------------------------------------------

        request.gender = loginVal.gender;

        // ------------------------------------------------
        // LIVING PREFERENCE
        // ------------------------------------------------

        if (logingender === "Female") {

            request.living_Preference = living_Preference
                .map(item => item.value)
                .join(",");
        }

        console.log(
            "FINAL FILTER REQUEST:",
            JSON.stringify(request, null, 2)
        );

        apply(request);
    }

    // ====================================================
    // VALIDATION
    // ====================================================

    function validation() {

        let isFlag = true;

        if (
            age_From === "" ||
            age_From === undefined ||
            ageTwo === "" ||
            ageTwo === undefined
        ) {

            setError("Please select your age options");

            isFlag = false;

        } else {

            setError("");
        }

        return isFlag;
    }

    // ====================================================
    // INITIAL LOAD
    // ====================================================

    useEffect(() => {

        stateAPICall();

        getFilterPreferences();

    }, []);

    // ====================================================
    // CASTE API
    // ====================================================

    function casteAPICall(religionId) {

        var request = new LookUpRequest();

        request.religion_id = religionId;

        console.log(
            "Caste Request:",
            JSON.stringify(request)
        );

        axios.get(
            ApiConfig.getUrl("User/MultiCaste"),
            {
                params: {
                    religion_id: religionId
                },

                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(response => {

                console.log(
                    "Caste API Response:",
                    response.data
                );

                const casteData =
                    response.data?.response?.casteList || [];

                const storecaste = casteData.map(item => ({
                    value: item.id,
                    label: item.name
                }));

                setCasteList(storecaste);

            })
            .catch(error => {

                console.error(
                    "Caste API Error:",
                    error
                );

            });
    }

    // ====================================================
    // STATE API
    // ====================================================

    function stateAPICall() {

        var request = new LookUpRequest();

        request.countrycode = "IN";

        console.log(
            "State Request:",
            JSON.stringify(request)
        );

        axios.get(
            ApiConfig.getUrl("User/multistate"),
            {
                params: {
                    countrycode: "IN"
                },

                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(response => {

                console.log(
                    "State API Response:",
                    response.data
                );

                const dataList =
                    response.data?.response?.dataList || [];

                const storestate = dataList.map(item => ({
                    value: item.code,
                    label: item.name,
                    id: item.id
                }));

                setStateList(storestate);

            })
            .catch(error => {

                console.error(
                    "State API Error:",
                    error
                );

            });
    }

    // ====================================================
    // DISTRICT API
    // ====================================================

    function districtAPICall(code) {

        var request = new LookUpRequest();

        request.state_code = code;

        console.log(
            "District Request:",
            JSON.stringify(request)
        );

        axios.get(
            ApiConfig.getUrl("User/Multidistrict"),
            {
                params: {
                    state_code: code
                },

                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(response => {

                console.log(
                    "District API Response:",
                    response.data
                );

                const dataList =
                    response.data?.response?.dataList || [];

                const storedistrict = dataList.map(item => ({
                    value: item.id,
                    label: item.name
                }));

                setDistrictList(storedistrict);

            })
            .catch(error => {

                console.error(
                    "District API Error:",
                    error
                );

            });
    }

    // ====================================================
    // GET SAVED FILTER PREFERENCES
    // ====================================================

    function getFilterPreferences() {

        if (!loginVal?.user_Id) {
            return;
        }

        axios.get(
            ApiConfig.getUrl("User/GetFilterPreferences"),
            {
                params: {
                    id: loginVal.user_Id
                },

                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {

                const data =
                    response.data?.response;

                if (!data) {
                    return;
                }

                console.log(
                    "Saved Filter Preferences:",
                    data
                );

                // IMPORTANT
                // Store complete response.
                // Dependent dropdowns will use this later.
                setSavedFilterData(data);

                // =================================================
                // AGE FROM
                // =================================================

                if (
                    data.age_From !== null &&
                    data.age_From !== undefined
                ) {

                    const fromAge =
                        String(data.age_From);

                    setAge_From(fromAge);

                    const saveIndex =
                        ages.findIndex(
                            age =>
                                String(age) === fromAge
                        );

                    if (saveIndex !== -1) {

                        setAge_To(
                            ages.slice(saveIndex)
                        );
                    }
                }

                // =================================================
                // AGE TO
                // =================================================

                if (
                    data.age_To !== null &&
                    data.age_To !== undefined
                ) {

                    setAgeTwo(
                        String(data.age_To)
                    );
                }

                // =================================================
                // RELIGION
                // =================================================

                if (data.religion) {

                    const religionIds =
                        String(data.religion)
                            .split(",")
                            .map(x => x.trim());

                    const savedReligion =
                        Religion.filter(item =>
                            religionIds.includes(
                                String(item.value)
                            )
                        );

                    setSelectedReligion(
                        savedReligion
                    );

                    // IMPORTANT:
                    // Load caste list for saved religion
                    casteAPICall(
                        religionIds.join(",")
                    );
                }

                // =================================================
                // MARITAL STATUS
                // =================================================

                if (data.marital_Status) {

                    const ids =
                        String(data.marital_Status)
                            .split(",")
                            .map(x => x.trim());

                    setSelectedMaritalStatus(
                        Martialstatus.filter(item =>
                            ids.includes(
                                String(item.value)
                            )
                        )
                    );
                }

                // =================================================
                // MOTHER TONGUE
                // =================================================

                if (data.mother_Tongue) {

                    const ids =
                        String(data.mother_Tongue)
                            .split(",")
                            .map(x => x.trim());

                    setSelectedMotherTongue(
                        Mothertongue.filter(item =>
                            ids.includes(
                                String(item.value)
                            )
                        )
                    );
                }

                // =================================================
                // EMPLOYMENT
                // =================================================

                if (data.employment_In) {

                    const ids =
                        String(data.employment_In)
                            .split(",")
                            .map(x => x.trim());

                    setSelectedEmployment(
                        EmploymentType.filter(item =>
                            ids.includes(
                                String(item.value)
                            )
                        )
                    );
                }

                // =================================================
                // FAMILY STATUS
                // =================================================

                if (data.family_Status) {

                    const ids =
                        String(data.family_Status)
                            .split(",")
                            .map(x => x.trim());

                    setSelectedFamilyStatus(
                        FamilyStatus.filter(item =>
                            ids.includes(
                                String(item.value)
                            )
                        )
                    );
                }

                // =================================================
                // FAMILY TYPE
                // =================================================

                if (data.family_Type) {

                    const ids =
                        String(data.family_Type)
                            .split(",")
                            .map(x => x.trim());

                    setSelectedFamilyType(
                        FamilyType.filter(item =>
                            ids.includes(
                                String(item.value)
                            )
                        )
                    );
                }

                // =================================================
                // FAMILY VALUES
                // =================================================

                if (data.family_Values) {

                    const ids =
                        String(data.family_Values)
                            .split(",")
                            .map(x => x.trim());

                    setSelectedFamilyValue(
                        FamilyValue.filter(item =>
                            ids.includes(
                                String(item.value)
                            )
                        )
                    );
                }

                // =================================================
                // LIVING PREFERENCE
                // =================================================

                if (data.living_Preference_Id) {

                    const ids =
                        String(data.living_Preference_Id)
                            .split(",")
                            .map(x => x.trim());

                    setliving_Preference(
                        LivingPreference.filter(item =>
                            ids.includes(
                                String(item.value)
                            )
                        )
                    );
                }

                // =================================================
                // HEIGHT
                // =================================================

                if (
                    data.height_From !== null &&
                    data.height_From !== undefined
                ) {

                    setHeightFrom(
                        String(data.height_From)
                    );
                }

                if (
                    data.height_To !== null &&
                    data.height_To !== undefined
                ) {

                    setHeightTo(
                        String(data.height_To)
                    );
                }

            })
            .catch(error => {

                console.error(
                    "GetFilterPreferences Error:",
                    error
                );

            });
    }

    // ====================================================
    // RESTORE CASTE
    //
    // casteList API first finishes.
    // Then saved caste IDs are selected.
    // ====================================================

    useEffect(() => {

        if (
            !savedFilterData?.cast ||
            casteList.length === 0
        ) {
            return;
        }

        const casteIds =
            String(savedFilterData.cast)
                .split(",")
                .map(x => x.trim());

        const savedCastes =
            casteList.filter(item =>
                casteIds.includes(
                    String(item.value)
                )
            );

        console.log(
            "Restored Caste:",
            savedCastes
        );

        setCaste(savedCastes);

    }, [savedFilterData, casteList]);

    // ====================================================
    // RESTORE STATE
    //
    // stateList API first finishes.
    // Then saved state IDs are selected.
    // Then district API is called.
    // ====================================================

    useEffect(() => {

        if (
            !savedFilterData?.state ||
            stateList.length === 0
        ) {
            return;
        }

        const stateIds =
            String(savedFilterData.state)
                .split(",")
                .map(x => x.trim());

        const savedStates =
            stateList.filter(item =>
                stateIds.includes(
                    String(item.id)
                )
            );

        console.log(
            "Restored State:",
            savedStates
        );

        setState(savedStates);

        // Load district list for saved states
        if (savedStates.length > 0) {

            const stateCodes =
                savedStates
                    .map(item => item.value)
                    .join(",");

            districtAPICall(
                stateCodes
            );
        }

    }, [savedFilterData, stateList]);

    // ====================================================
    // RESTORE DISTRICT
    //
    // districtList API first finishes.
    // Then saved district IDs are selected.
    // ====================================================

    useEffect(() => {

        if (
            !savedFilterData?.district ||
            districtList.length === 0
        ) {
            return;
        }

        const districtIds =
            String(savedFilterData.district)
                .split(",")
                .map(x => x.trim());

        const savedDistricts =
            districtList.filter(item =>
                districtIds.includes(
                    String(item.value)
                )
            );

        console.log(
            "Restored District:",
            savedDistricts
        );

        setDistrict(savedDistricts);

    }, [savedFilterData, districtList]);

    // ====================================================
    // OCCUPATION
    // ====================================================

    const handleOccupationChange = (x) => {

        console.log(
            "Occupation:",
            x
        );

        setSelectedOccupation(x);
    };

    // ====================================================
    // EDUCATION
    // ====================================================

    const handleEducationChange = (x) => {

        console.log(
            "Education:",
            x
        );

        setSelectedEducation(x);
    };

    // ====================================================
    // RIGHT CLICK DISABLE
    // ====================================================

    const disableRightClick = (e) => {

        e.preventDefault();

    };

    // ====================================================
    // JSX
    // ====================================================

    return (

        <div
            className='mt-2 w-100'
            style={{
                fontFamily:
                    "Arial, Helvetica, sans-serif"
            }}
            onContextMenu={disableRightClick}
        >

            {/* LOADER */}

            {isLoading && (

                <div className="loader-overlay">

                    <Oval
                        height={60}
                        width={60}
                        color="#ffffff"
                        secondaryColor="#cccccc"
                        strokeWidth={4}
                        visible={true}
                    />

                </div>
            )}

            <div className="filter-container">

                {/* ==========================================
                    AGE
                ========================================== */}

                <div className="filter-full">

                    <label className="filter-label">
                        Age
                    </label>

                    <div className="age-row">

                        {/* AGE FROM */}

                        <select
                            className="age-select"
                            value={age_From || ""}
                            onChange={(e) => {

                                const saveIndex =
                                    e.target.selectedIndex;

                                const newAgeTo =
                                    ages.slice(saveIndex);

                                setAge_To(newAgeTo);

                                setAge_From(
                                    e.target.value
                                );
                            }}
                        >

                            <option value="">
                                Select age From
                            </option>

                            {ages.map(
                                (age, index) => (

                                    <option
                                        key={index}
                                        value={age}
                                    >
                                        {age}
                                    </option>
                                )
                            )}

                        </select>

                        <span className="age-to-text text-dark text-decoration-none">
                            to
                        </span>

                        {/* AGE TO */}

                        <select
                            className="age-select"
                            value={ageTwo || ""}
                            onChange={(e) =>
                                setAgeTwo(
                                    e.target.value
                                )
                            }
                        >

                            <option value="">
                                Select age To
                            </option>

                            {age_To.map(
                                age => (

                                    <option
                                        key={age}
                                        value={age}
                                    >
                                        {age}
                                    </option>
                                )
                            )}

                        </select>

                    </div>

                    <span className="text-danger">
                        {error}
                    </span>

                </div>

                {/* ==========================================
                    RELIGION
                ========================================== */}

                <div className="filter-item">

                    <label className="filter-label">
                        Religion
                    </label>

                    <Select
                        className="filter-select"
                        classNamePrefix="react-select"
                        options={Religion}
                        value={selectedReligion}
                        isMulti
                        placeholder="Select Religion"

                        onChange={(value) => {

                            const selected =
                                value || [];

                            setSelectedReligion(
                                selected
                            );

                            // Clear old caste
                            setCaste([]);

                            setCasteList([]);

                            if (
                                selected.length > 0
                            ) {

                                const religionIds =
                                    selected
                                        .map(
                                            r => r.value
                                        )
                                        .join(",");

                                casteAPICall(
                                    religionIds
                                );
                            }

                        }}
                    />

                </div>

                {/* ==========================================
                    CASTE
                ========================================== */}

                <div className="filter-item">

                    <label className="filter-label">
                        Caste
                    </label>

                    <Select
                        className="filter-select"
                        classNamePrefix="react-select"
                        options={casteList}
                        value={caste}
                        isMulti
                        placeholder="Select Caste"

                        onChange={(value) =>
                            setCaste(
                                value || []
                            )
                        }
                    />

                </div>

                {/* ==========================================
                    STATE
                ========================================== */}

                <div className="filter-item">

                    <label className="filter-label">
                        State
                    </label>

                    <Select
                        className="filter-select"
                        classNamePrefix="react-select"
                        options={stateList}
                        value={state}
                        isMulti
                        placeholder="Select State"

                        onChange={(value) => {

                            const selected =
                                value || [];

                            setState(
                                selected
                            );

                            // Clear old district
                            setDistrict([]);

                            setDistrictList([]);

                            if (
                                selected.length > 0
                            ) {

                                const stateCodes =
                                    selected
                                        .map(
                                            item =>
                                                item.value
                                        )
                                        .join(",");

                                districtAPICall(
                                    stateCodes
                                );
                            }

                        }}
                    />

                </div>

                {/* ==========================================
                    DISTRICT
                ========================================== */}

                <div className="filter-item">

                    <label className="filter-label">
                        District
                    </label>

                    <Select
                        className="filter-select"
                        classNamePrefix="react-select"
                        options={districtList}
                        value={district}
                        isMulti
                        placeholder="Select District"

                        onChange={(value) =>
                            setDistrict(
                                value || []
                            )
                        }
                    />

                </div>

                {/* ==========================================
                    MARITAL STATUS
                ========================================== */}

                <div className="filter-item">

                    <label className="filter-label">
                        Marital Status
                    </label>

                    <Select
                        className="filter-select"
                        classNamePrefix="react-select"
                        options={Martialstatus}
                        value={selectedMaritalStatus}
                        isMulti
                        placeholder="Marital Status"

                        onChange={(value) =>
                            setSelectedMaritalStatus(
                                value || []
                            )
                        }
                    />

                </div>

                {/* ==========================================
                    MOTHER TONGUE
                ========================================== */}

                <div className="filter-item">

                    <label className="filter-label">
                        Mother Tongue
                    </label>

                    <Select
                        className="filter-select"
                        classNamePrefix="react-select"
                        options={Mothertongue}
                        value={selectedMotherTongue}
                        isMulti
                        placeholder="Mother Tongue"

                        onChange={(value) =>
                            setSelectedMotherTongue(
                                value || []
                            )
                        }
                    />

                </div>

                {/* ==========================================
                    EMPLOYMENT
                ========================================== */}

                <div className="filter-item">

                    <label className="filter-label">
                        Employment Type
                    </label>

                    <Select
                        className="filter-select"
                        classNamePrefix="react-select"
                        options={EmploymentType}
                        value={selectedEmployment}
                        isMulti
                        placeholder="Employment Type"

                        onChange={(value) =>
                            setSelectedEmployment(
                                value || []
                            )
                        }
                    />

                </div>

                {/* ==========================================
                    FAMILY STATUS
                ========================================== */}

                <div className="filter-item">

                    <label className="filter-label">
                        Family Status
                    </label>

                    <Select
                        className="filter-select"
                        classNamePrefix="react-select"
                        options={FamilyStatus}
                        value={selectedFamilyStatus}
                        isMulti
                        placeholder="Family Status"

                        onChange={(value) =>
                            setSelectedFamilyStatus(
                                value || []
                            )
                        }
                    />

                </div>

                {/* ==========================================
                    FAMILY TYPE
                ========================================== */}

                <div className="filter-item">

                    <label className="filter-label">
                        Family Type
                    </label>

                    <Select
                        className="filter-select"
                        classNamePrefix="react-select"
                        options={FamilyType}
                        value={selectedFamilyType}
                        isMulti
                        placeholder="Family Type"

                        onChange={(value) =>
                            setSelectedFamilyType(
                                value || []
                            )
                        }
                    />

                </div>

                {/* ==========================================
                    FAMILY VALUE
                ========================================== */}

                <div className="filter-item">

                    <label className="filter-label">
                        Family Value
                    </label>

                    <Select
                        className="filter-select"
                        classNamePrefix="react-select"
                        options={FamilyValue}
                        value={selectedFamilyValue}
                        isMulti
                        placeholder="Family Value"

                        onChange={(value) =>
                            setSelectedFamilyValue(
                                value || []
                            )
                        }
                    />

                </div>

                {/* ==========================================
                    LIVING PREFERENCE
                    FEMALE ONLY
                ========================================== */}

                {logingender === "Female" && (

                    <div className="filter-item">

                        <label className="filter-label">
                            Living Preference
                        </label>

                        <Select
                            className="filter-select"
                            classNamePrefix="react-select"
                            options={LivingPreference}
                            value={living_Preference}
                            isMulti
                            placeholder="Living Preference"

                            onChange={(value) =>
                                setliving_Preference(
                                    value || []
                                )
                            }
                        />

                    </div>
                )}

                {/* ==========================================
                    APPLY
                ========================================== */}

                <div className="apply-container">

                    <button
                        onClick={FilterAPICall}
                        type="button"
                        className="apply-btn"
                    >
                        Apply
                    </button>

                </div>

            </div>

        </div>
    );
}

export default Filter;